import React, { FC, ReactElement } from 'react';
import { ExerciseDto } from '../../../../shared/dtos/exercise.dto';
import { ExerciseTagDto } from '../../../../shared/dtos/exerciseTag.dto';
import i18next from 'i18next';
import { EntityScope } from '../../../../shared/utils/enums';
import { Modal } from 'react-bootstrap';
import AppModal from '../app-modal/AppModal';
import ExerciseForm from './ExerciseForm';

type ExerciseModalProps = {
  show: boolean;
  entityScope: EntityScope;
  tags: ExerciseTagDto[];
  exerciseVideo: ExerciseDto | null;
  isSuperAdmin: boolean;
  onClose: () => void;
  onSave: () => void;
}

const ExerciseModal: FC<ExerciseModalProps> = ({
  show,
  entityScope,
  tags,
  exerciseVideo,
  isSuperAdmin,
  onClose,
  onSave
}: ExerciseModalProps): ReactElement => {

  return (
    <AppModal size="xl" dialogClassName="modal-90w" show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t(exerciseVideo ? 'exerciseVideoModal.updateExercise' : 'exerciseVideoModal.createExercise')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ExerciseForm
          initialData={exerciseVideo}
          tags={tags}
          isSuperAdmin={isSuperAdmin}
          entityScope={entityScope}
          onCancel={onClose}
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default ExerciseModal;
